module.exports = __webpack_public_path__ + "media/bootstrap-icons/trash-d55ba7a6.svg";